import { Labeled, ReferenceField, TextField } from "react-admin";
import { RESOURCE_NAME_ACCOUNT } from "../../../lib/modules";

const VendorNameField = ({
  source = "vendorAccountId",
  label = "common.fields.vendorName",
  useLabel = true,
}: {
  source?: string;
  label?: string;
  useLabel?: boolean;
}) => {
  if (useLabel) {
    return (
      <Labeled id={label} source={source} label={label}>
        <ReferenceField
          label={label}
          source={source}
          reference={RESOURCE_NAME_ACCOUNT}
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
      </Labeled>
    );
  } else {
    return (
      <ReferenceField
        label={label}
        source={source}
        reference={RESOURCE_NAME_ACCOUNT}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
    );
  }
};

export { VendorNameField };
